import React, { useState } from "react";
import './Navbar.css';
import logo from '../../images/logo-thestudycafe.png';
import { FaBars } from 'react-icons/fa'; // Import the hamburger icon

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    // Toggle menu open/close state
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <>
            <nav className="navbar">
                <div className="navbar-container" id="home">
                    {/* Left Side: Logo and Brand Name */}
                    <div className="navbar-logo">
                        <img src={logo} alt="Logo" className="logo-image" />
                        <span className="brand-name">The Study Cafe Library</span>
                    </div>

                    {/* Hamburger Icon for mobile view, placed on the right side */}
                    <div className="hamburger-icon" onClick={toggleMenu}>
                        <FaBars />
                    </div>

                    {/* Right Side: Navigation Links */}
                    <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
                        <li><a href="#home">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#charges">Charges</a></li>
                        <li><a href="#facilities">Facilities</a></li>
                        <li><a href="#reviews">Reviews</a></li>
                        <li><a href="#contact">Contact Us</a></li>
                    </ul>
                </div>
            </nav>
        </>
    );
}

export default Navbar;
